export const CODE_FOR_STREAM = 'codeforstream'
export const NO_VIDEO = 'NoVideo'
